import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'mneDate', standalone: true })
export class MneDatePipe implements PipeTransform {
  transform(value: string | number | null | undefined, withTime = true): string {
    if (value == null || value === '') return '—';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return String(value);
    const pad = (n: number) => String(n).padStart(2, '0');
    const datePart = `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()}`;
    if (!withTime) return datePart;
    return `${datePart} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
  }
}
